import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import StaffTasks from './component';

export default ({ getState }) => ({
  path: '/staff-tasks',
  component: StaffTasks,
  tab: {
    label: 'Staff Tasks',
    order: 1,
    isVisible: () => PrivilegeChecker.hasPrivilege(
    getState(), Privileges.GroupDashboard.ViewStaffTasksInformation),
  },
  canAccess: () => PrivilegeChecker.hasPrivilege(
    getState(), Privileges.GroupDashboard.ViewStaffTasksInformation),
});



// WEBPACK FOOTER //
// ./containers/UserDashboard/TeacherTasks/routes.js